import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import { DeviationDuperbrowseContext } from '../../../Duperbrowse';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import MeasuredDeviationsMosaic from '../../../MeasuredDeviationsMosaic';

const MOSAIC_HEIGHT = 289; // 321 - 2 * 16 because the measured mosaic has paddings removed

interface Props {
  streamId: string;
  deviations: PapiDeviation[];
  parentDeviation: PapiDeviation;
  className?: string;
}

const DeviationSidebarMosaic: React.FC<React.PropsWithChildren<Props>> = ({
  streamId,
  deviations,
  parentDeviation,
  className,
}) => {
  const preloadEnabled = false;

  return (
    <DeviationDuperbrowseContext
      preloadEnabled={preloadEnabled}
      streamId={streamId}
      deviations={deviations}
      parent={{
        typeId: getDeviationResourceType(parentDeviation),
        itemId: parentDeviation.deviationId,
      }}
    >
      <MeasuredDeviationsMosaic
        deviations={deviations.slice(0, 3)}
        height={MOSAIC_HEIGHT}
        cookieType={MeasuredCookieType.DEVIATION_SIDEBAR}
        className={className}
      />
    </DeviationDuperbrowseContext>
  );
};
DeviationSidebarMosaic.displayName = 'DeviationSidebarMosaic';

export default DeviationSidebarMosaic;
